export default {
  title: 'NFSe'
};
